package app

import app.properties.*
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.onChangeFunction
import react.*
import react.dom.*

interface PersonState : RState {
    var person: Person?
}

class PersonInfoForm(props: PersonInterface) : RComponent<PersonInterface, PersonState>(props) {
    init {
        state.person = this.props.person
    }
    private var familyTypesList = props.familyTypes
    private var educationTypesList = props.educationTypes

    override fun componentDidMount() {
        val datepicker = js("""jQuery('#birthdayDatepicker').datepicker({
                            format: 'dd/mm/yyyy',
                            minViewMode: "2",
                            endDate: "-18y",
                            autoclose: true
                        });""")

        datepicker.on("change", fun() {
            setState {
                person?.birthDay = datepicker.datepicker("getFormattedDate")
            }
        })
    }

    override fun RBuilder.render() {
        div("row") {
            div("col-lg col-md-12") {
                label { +"Անուն" }
                input(classes = "form-control") {
                    attrs {
                        if(props.person?.firstName == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = props.person?.firstName ?: ""
                    attrs.onChangeFunction = {
                        val firstName = getTargetValue(it)
                        setState {
                            person?.firstName = firstName
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"Ազգանուն" }
                input(classes = "form-control") {
                    attrs {
                        if(props.person?.lastName == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = props.person?.lastName ?: ""
                    attrs.onChangeFunction = {
                        val lastName = getTargetValue(it)
                        setState {
                            person?.lastName = lastName
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"Հայրանուն" }
                input(classes = "form-control") {
                    attrs {
                        if(props.person?.parentName == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = props.person?.parentName ?: ""
                    attrs.onChangeFunction = {
                        val parentName = getTargetValue(it)
                        setState {
                            person?.parentName = parentName
                        }
                    }
                }
            }
        }
        div("row") {
            div("col-lg col-md-12") {
                label { +"Ծննդյան տարեթիվ /օր, ամիս, տարի/" }
                input(classes = "form-control") {
                    attrs {
                        if(props.person?.birthDay == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = props.person?.birthDay ?: ""
                    attrs.id = "birthdayDatepicker"
                }
            }
            div("col-lg col-md-12") {
                label { +"Ամուսնական կարգավիճակ" }
                select("form-control") {
                    attrs.name = "companyType"
                    attrs["value"] = familyTypesList?.indexOfFirst { it.id == props.person?.familyType?.id }.toString()
                    attrs.onChangeFunction = {
                        val index = getTargetValueToInt(it)
                        val companyType = if (index == null)  null  else familyTypesList?.get(index)
                        setState {
                            props.person?.familyType = companyType
                        }
                    }
                    option { +"Ընտրել ամուսնական կարգավիճակը" }
                    familyTypesList?.forEachIndexed { index, familyType ->
                        option {
                            attrs["value"] = index.toString()
                            +familyType.name
                        }
                    }
                }
            }
            div("col-lg col-md-12") {
                label { +"Ընտանիքի անդամներ" }
                input(classes = "form-control") {
                    attrs {
                        if(props.person?.familyPersonCount == 0 && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = props.person?.familyPersonCount.toString()
                    attrs.onChangeFunction = {
                        val familyPersonCount = getTargetValueToInt(it)
                        setState {
                            person?.familyPersonCount = familyPersonCount ?: 1
                        }
                    }
                }
            }
        }
        div("row") {
            div("col-lg col-md-12") {
                label { +"Մարզ" }
                select("form-control") {

                    attrs["value"] = props.regionList?.indexOfFirst { it.id == state.person?.region?.id }.toString()
                    attrs {
                        if(state.person?.region == null && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }

                    attrs.onChangeFunction = {
                        val index = getTargetValueToInt(it)
                        val region = if (index == null)  null  else props.regionList?.get(index)
                        setState {
                            person?.region = region
                        }
                    }
                    option { +"Ընտրել մարզը" }
                    props.regionList?.forEachIndexed { index, region ->
                        option {
                            attrs.value = index.toString()
                            +region.name
                        }
                    }
                }
            }

            div("col-lg col-md-12") {
                label { +"Համայնք" }
                input(InputType.email, classes = "form-control") {
                    attrs {
                        if(state.person?.area == null && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = state.person?.area ?: ""
                    attrs.onChangeFunction = {
                        val area = getTargetValue(it)
                        setState {
                            person?.area = area
                        }
                    }
                }
            }
        }
        div("row") {
            div("col-lg col-md-12") {
                label { +"Բնակության հասցե" }
                input(classes = "form-control") {
                    attrs {
                        if(props.person?.address == "" && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs["value"] = props.person?.address ?: ""
                    attrs.onChangeFunction = {
                        val address = getTargetValue(it)
                        setState {
                            person?.address = address
                        }
                    }
                }
            }


            div("col-lg col-md-12") {
                label { +"Կրթական մակարդակ" }
                select("form-control") {
                    attrs {
                        if(props.person?.education == null && props.touch) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                    attrs.name = "companyType"
                    attrs["value"] = educationTypesList?.indexOfFirst { it.id == props.person?.education?.id }.toString()
                    attrs.onChangeFunction = {
                        val index = getTargetValueToInt(it)
                        val educationType = if (index == null)  null  else educationTypesList?.get(index)
                        setState {
                            props.person?.education = educationType
                        }
                    }
                    option { +"Ընտրել կրթական մակարդակը" }
                    educationTypesList?.forEachIndexed { index, educationType ->
                        option {
                            attrs["value"] = index.toString()
                            +educationType.name
                        }
                    }
                }
            }
        }
    }
}

interface PersonInterface : RProps {
    var person: Person?
    var familyTypes: Array<FamilyType>?
    var educationTypes: Array<EducationType>?
    var regionList: Array<Region>?
    var touch: Boolean
}
fun RBuilder.personInfoForm(person: Person?, familyTypes: Array<FamilyType>?, educationTypes: Array<EducationType>?, regionList: Array<Region>?, touch: Boolean) = child(PersonInfoForm::class) {
    attrs.person = person
    attrs.familyTypes = familyTypes
    attrs.educationTypes = educationTypes
    attrs.regionList = regionList
    attrs.touch = touch
}

